import { intersectionObserve } from "./_intersection-observer";

function loadTarget(target) {
    if (target.classList && target.classList.contains('loaded')) {
        return;
    }

    if (target.tagName === 'IMG') {
        target.onload = function() {
            showElement(target);
        }
        target.src = target.getAttribute('data-src');
        target.classList.add('loaded');
    }
}

function showElement(element) {
    if (element.classList) {
        if (!element.classList.contains('show-img')) {
            element.classList.add('show-img');
        }
    } else {
        element.className += ' show-img';
    }
}

let images = document.querySelectorAll('img.lazy');
intersectionObserve(images, 0, 0.8, (image, intersectionRatio) => {
    (function(el) {
        if (intersectionRatio > 0 && !el.classList.contains('show-img')) {
            el.classList.add('show-img');
            loadTarget(el);
        } 
    })(image);
});